import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import CssBaseline from '@mui/material/CssBaseline';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import { Button, Grid2, Stack, ThemeProvider } from '@mui/material';
import Container from '@mui/material/Container';
import Slide from '@mui/material/Slide';

import RunnerContent from './components/RunnerContent'
import ObiContent from './components/ObiContent'
import theme from './themes/classicLight'
import Intro from './components/Intro';
import About from './components/About';
import Importance from './components/Importance';
import Features from './components/Features';
import Footer from './components/Footer';
import Content from './components/Content';

function HideOnScroll(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
  });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children ?? <div />}
    </Slide>
  );
}

HideOnScroll.propTypes = {
  children: PropTypes.element,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default function HideAppBar(props) {
  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>
        <CssBaseline />


        <Container className='secondary-gradient' maxWidth="true" sx={{ pt: 5 }}>
          <HideOnScroll {...props}>
            <AppBar sx={{ boxShadow: 'none', py: '2rem', background: 'transparent' }}  >
              <Toolbar>
                <Container maxWidth="xl">

                  <a href={process.env.REACT_APP_HOME} target='_blank' rel="noreferrer">
                    <img src={process.env.REACT_APP_CDN + '/sys/img/callgoose_logo_text.svg'} width={180} height='auto' alt="Callgoose SQIBS" />
                  </a>
                </Container>

              </Toolbar>
            </AppBar>
          </HideOnScroll>
          <Container maxWidth="xl" sx={{ mt: 5 }}>

            <Grid2 container justifyContent={'space-between'}>
              <Grid2 size={{ xs: 12, lg: 7, xl: 6 }} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <Stack
                  sx={{
                    height: "100%", textAlign: { xs: "center", md: "left" }, mb: '2rem',
                    px: { xs: 5, lg: 0 }
                  }}
                  justifyContent="center"
                  alignItems={{ xs: "center", md: "flex-start" }}
                  spacing={2}
                >
                  <Typography variant={"h2"} component="h3">
                    Transform <br /> Your Business<br /> with Automation
                  </Typography>
                  <Typography sx={{ pr: { xs: 0, lg: 30 } }}>

                    Advanced Automation platform with effective On-Call schedule, real-time Incident Management and Incident Response capabilities that keep your organization more resilient, reliable, and always on
                  </Typography>
                </Stack>
              </Grid2>

              <Grid2 size={{ xs: 12, lg: 4, xl: 4 }} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <img src={process.env.REACT_APP_CDN + '/sys/img/callgoose_sqibs_automation_banner.svg'} alt={'Process automation'} width="100%"
                  className="img-shadow"
                />
              </Grid2>

            </Grid2>

          </Container>
        </Container>


        <About />
        <Content />
        <Intro />
        <br />
        <br />
        <Importance />
        <br />
        <br />
        <Features />
        <br />
        <br />
        <Container maxWidth="xl" >
          <Grid2 container justifyContent={'space-between'}>
            <Grid2 size={{ xs: 12 }}>
              <Typography variant='h4' gutterBottom>Deployment Options</Typography>

            </Grid2>
          </Grid2>
        </Container>
        <RunnerContent />
        <ObiContent />


        <br />
        <Container maxWidth="xl" >
          <Grid2 container justifyContent={'space-between'}>
            <Grid2 size={{ xs: 12 }}>
              <a href={process.env.REACT_APP_RESOURCES} target='_blank' rel="noreferrer">
                <Button variant="contained" size="large">Click here to learn more and explore</Button>

              </a>

            </Grid2>
          </Grid2>
        </Container>
        <br />
        <br />
        <Footer />

      </ThemeProvider>

    </React.Fragment>
  );
}
